import { FunctionComponent, useEffect, useState } from 'react'
import { DayPicker, Matcher } from 'react-day-picker'
import moment from 'moment-timezone'
import { getDaycareWeekClosingDay } from '@/modules/helper/daycareHelper'
import styles from './selectMultipleDateDialog.module.scss'
import { ClosingDay } from '@/types/ClosingDays'
import { getLocalFromLanguage } from '@/modules/helper/languageHelper'
import { useCurrentDaycareInfos } from '@/hooks/useCurrentDaycareInfos'

interface SelectMultipleDateDialogProps {
    dateList: string[]
    setDateList: (dateList: string[]) => void
    closingDays: ClosingDay[]
    startDate: string
    isParent?: boolean
    otherDisabledDates?: Date[]
}

const SelectMultipleDateDialog: FunctionComponent<SelectMultipleDateDialogProps> = ({
    dateList,
    setDateList,
    closingDays,
    startDate,
    isParent,
    otherDisabledDates
}: SelectMultipleDateDialogProps) => {
    const [disabled, setDisabled] = useState<Matcher[]>([])
    const [hiddenDays, setHiddenDays] = useState<Matcher>()
    const { currentDaycare: daycare } = useCurrentDaycareInfos()

    useEffect(() => {
        const baseDisabled: Matcher[] = [
            {
                dayOfWeek: getDaycareWeekClosingDay(daycare)
            },
            {
                before: moment().toDate()
            }
        ]

        if (otherDisabledDates && otherDisabledDates.length > 0) {
            baseDisabled.push(
                ...otherDisabledDates.map(
                    (date: Date): Matcher => ({
                        from: date,
                        to: date
                    })
                )
            )
        }

        setDisabled(baseDisabled)

        const closingDaysList: Date[] = []

        closingDays.map((closingDay: ClosingDay): void => {
            const from: Date = moment(closingDay.startDate, 'DD-MM-YYYY').toDate()
            const to: Date = moment(closingDay.endDate, 'DD-MM-YYYY').toDate()

            let currentDate: Date = from
            while (currentDate <= to) {
                closingDaysList.push(currentDate)
                currentDate = moment(currentDate).add(1, 'days').toDate()
            }
        })

        setHiddenDays(closingDaysList)
    }, [daycare, closingDays])

    return (
        <div>
            <DayPicker
                defaultMonth={moment(startDate, 'DD-MM-YYYY').toDate()}
                disabled={disabled}
                hidden={hiddenDays}
                locale={getLocalFromLanguage()}
                mode={'multiple'}
                selected={dateList.map((date: string): Date => moment(date, 'DD-MM-YYYY').toDate())}
                onSelect={(days: Date[] | undefined) => {
                    if (!days) {
                        setDateList([])
                        return
                    }
                    const newDateList: string[] = days.map((day: Date): string => moment(day).format('DD-MM-YYYY'))
                    setDateList(newDateList)
                }}
                modifiersClassNames={{
                    selected: isParent ? styles.SelectedDayParent : styles.SelectedDayDaycare,
                    hideDays: styles.HiddenDay,
                    today: styles.Today
                }}
                className={isParent ? styles.DayPickerParent : styles.DayPickerDaycare}
            />
        </div>
    )
}

export default SelectMultipleDateDialog
